import { Fragment } from 'react';
import TimeAward from './../../../commons/components/Award/TimeAward';
import AwardTop from './../../../commons/components/Award/AwardTop';
import ROUTERS from '../../../commons/constans/router';
import LoadingAward from '../../../commons/components/Award/LoadingAward';
import { ReactComponent as ImgAwards} from '../../../assets/images/img_awards.svg';
import AwardImgBackgroundSpring from '../../../assets/images/awards_banner_spring.png';
import AwardImgBackgroundSummer from '../../../assets/images/awards_banner_summer.png';
import AwardImgBackgroundWinter from '../../../assets/images/awards_banner_winter.png';
import AwardImgBackgroundFall from '../../../assets/images/awards_banner_fall.png';
import ImgRankingBg from '../../../assets/images/img_ranking_bakground.png';

import moment from 'moment'

const getBackgroundImage = () => {
  const year = moment().format('Y')
  const now = moment()
  // 2022-12-01 00:00:00 - 2023-02-28 23:59:59 WINTER
  if (
    now.diff(moment((year - 1) + '-12-01 00:00:00'), 'seconds') >= 0
    && now.diff(moment(year + '-02-28 23:59:59'), 'seconds') <= 0
  ) {
    return AwardImgBackgroundWinter
  }
  // 2023-03-01 00:00:00 - 2023-05-31 23:59:59 SPRING
  if (
    now.diff(moment((year) + '-03-01 00:00:00'), 'seconds') >= 0
    && now.diff(moment(year + '-05-31 23:59:59'), 'seconds') <= 0
  ) {
    return AwardImgBackgroundSpring
  }
  // 2023-06-01 00:00:00 - 2023-08-31 23:59:59 SUMMER
  if (
    now.diff(moment(year + '-06-01 00:00:00'), 'seconds') >= 0
    && now.diff(moment(year + '-08-31 23:59:59'), 'seconds') <= 0
  ) {
    return AwardImgBackgroundSummer
  }
  // 2023-09-01 00:00:00 - 2023-11-30 23:59:59 AUTUMN
  if (
    now.diff(moment(year + '-09-01 00:00:00'), 'seconds') >= 0
    && now.diff(moment(year + '-11-30 23:59:59'), 'seconds') <= 0
  ) {
    return AwardImgBackgroundFall
  }
}

const Awards = ({ award = {}, entries = [] }) => {
  // const imageUrl = award?.season_image_url?.thumbnail
  // const imageUrl =
  //   'https://sphokidz-media.s3.ap-northeast-2.amazonaws.com/original/banner/121/banner_167541707695370.png';
  // const background = `linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(9, 9, 121, 0) 65%, rgb(255, 255, 255) 100%), url("${imageUrl}")`
  const background = `url("${getBackgroundImage()}")`;

  return (
    <Fragment>
      <div className="award-precious">
        <div
          style={{ backgroundImage: background, backgroundSize: 'cover' }}
        ></div>
      </div>
      {award.id ? (
        <>
          <div className="box-awards" style={{backgroundImage: `url("${ImgRankingBg}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundColor: '#fff'}}>
            <div className="box-awards__header">
              <div className="icon-awards">
                {/* <img src={ImgAwards} alt="" /> */}
                <span className=''>
                  <ImgAwards />
                </span>
              </div>
            </div>

            <div className="box-awards__content">
              <AwardTop
                entries={entries}
                omitTop7
                className="pb-1"
                previewLink={ROUTERS.AWARD}
              />
            </div>
          </div>
          <div className="bg-white">
            <TimeAward award={award} onlyTime />
          </div>
        </>
      ) : (
        <LoadingAward />
      )}
    </Fragment>
  );
};

export default Awards;
